import React from "react";
import PageFooter from "../../../components/loggedout/Footer/index";
import * as S from "./style";

const Footer = () => {
  return (
    <S.FooterContainer>
      <PageFooter showOddbodsTrademark={true} />
    </S.FooterContainer>
  )
}

export default Footer;